import { Container, List, Paper } from '@mui/material';
import type { PageProps } from 'gatsby';
import React from 'react';
// import Main from '@views/Records/Legal/Main';
import { useIntl, defineMessages } from 'react-intl';

import MainTitle from '@components/MainTitle';

import AppLayout from '@layouts/AppLayout';

import LegalList from '@views/Records/Legal/LegalList';
import RelatedPersonList from '@views/Records/Legal/RelatedPersonList';

const messages = defineMessages({
  title: {
    id: 'legalMain.title',
    defaultMessage: 'Legal/Directives',
  },
});

export default function LegalPage({ params }: PageProps) {
  const { formatMessage } = useIntl();
  return (
    <AppLayout friendlyName={formatMessage(messages.title)} showHeader>
      <Container maxWidth="sm" sx={{ pt: 3 }}>
        <MainTitle title={formatMessage(messages.title)} />
        <Paper>
          <List>
            <RelatedPersonList {...params} />
            <LegalList {...params} />
          </List>
        </Paper>
      </Container>
    </AppLayout>
  );
}
